import {
  provideTransloco,
  TranslocoModule,
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from 'src/environments/environment';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
      storageKey: 'lang'
    }),
    provideTransloco({
      config: {
        availableLangs: ['en', 'it'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader
    }),
  ],
})
export class TranslocoRootModule {}
